import Vue from 'vue';
import { Utils } from '@/services/utils/BasicUtils';
import { forEach } from 'lodash-es';
import { ThemeOption } from '@/env/services/EnvironmentTheme';
import { StorageKeys } from '@/commons/enums/StorageKeys';
import { useThemeCookie } from '@/composables/useThemeCookie';
import { Theme } from '@/types/Theme';

export function setupTheme(theme: ThemeOption) {
  try {
    const themeCookie = useThemeCookie();

    Vue.prototype.$vuetify.theme.dark = themeCookie.value === Theme.DARK;
    //set default theme if not set for zitadel page setup
    if (!themeCookie.value) {
      themeCookie.value = Theme.LIGHT;
    }

    changeTheme(theme);
    // createRgbVarsForThemes(Vue.prototype.$vuetify.theme.themes);
  } catch (e) {
    console.error('Błąd podczas inicjalizacji motywu:', e);
  }
}

export function changeTheme(theme: ThemeOption) {
  try {
    forEach(theme, (mode, key) => {
      Vue.prototype.$vuetify.theme.themes[key] = Utils.assign(Vue.prototype.$vuetify.theme.themes[key], mode);
    });
  } catch (e) {
    console.warn(e);
  }
}

export function toggleTheme() {
  try {
    const getToggledTheme = (theme: Theme) => theme === Theme.DARK ? Theme.LIGHT : Theme.DARK;

    const themeCookie = useThemeCookie();

    Vue.prototype.$vuetify.theme.dark = !Vue.prototype.$vuetify.theme.dark;
    themeCookie.value = getToggledTheme(themeCookie.value || Theme.LIGHT);
  } catch (e) {
    console.error('Błąd podczas przełączania motywu:', e);
  }
}

export function getConfigValue(storageKey: StorageKeys): string | null {
  return localStorage.getItem(storageKey);
}

export function getConfigBooleanValue(storageKey: StorageKeys): boolean {
  return getConfigValue(storageKey) === 'true';
}

export function saveConfigValue(storageKey: StorageKeys, value: any) {
  return localStorage.setItem(storageKey, JSON.stringify(value));
}
